import { httpService } from 'core/services/httpService';   

export async function getPaymentsReportData(params, options={}){
  return httpService.GET({url: `:businessId:/reports/payment`, params}, options);
};

export async function downloadPaymentsReport(params, options={}) {
  return httpService.FILE({url: `:businessId:/reports/payment`, params}, options);
}

export async function getSecurityDepositReportData(params, options={}) {
  return httpService.GET({url: `:businessId:/reports/advance`, params}, options);
}

export async function downloadSecurityDepositReport(params, options={}) {
  return httpService.FILE({url: `:businessId:/reports/advance`, params}, options);
}

export async function getCheckoutReportData(params, options={}){
  return httpService.GET({url: `:businessId:/reports/checkout`, params}, options);
};
export async function downloadCheckoutReport(params, options={}) {
  return httpService.FILE({url: `:businessId:/reports/checkout`, params}, options);
}

export async function getExpenseReportData(params, options={}){
  return httpService.GET({url: `:businessId:/reports/expense`, params}, options);
};
export async function downloadExpenseReport(params, options={}) {
  return httpService.FILE({url: `:businessId:/reports/expense`, params}, options);
}

export async function getSMSReportData(params, options={}){
  return httpService.GET({url: `:businessId:/reports/sms`, params}, options);
};
export async function downloadSMSReport(params, options={}) {
  return httpService.FILE({url: `:businessId:/reports/sms`, params}, options);
}

export async function getFoodReportData(params, options={}){
  return httpService.GET({url: `:businessId:/reports/food`, params}, options);
};
export async function downloadFoodReport(params, options={}) {
  return httpService.FILE({url: `:businessId:/reports/food`, params}, options);
}

export async function getBookingReportData(params, options={}){
  return httpService.GET({url: `:businessId:/reports/booking`, params}, options);
};
export async function downloadBookingReport(params, options={}) {
  return httpService.FILE({url: `:businessId:/reports/booking`, params}, options);
}

export async function getPayoutReportData(params, options={}){
  return httpService.GET({url: `:businessId:/reports/payout`, params}, options);
};
export async function downloadPayoutReport(params, options={}) {
  return httpService.FILE({url: `:businessId:/reports/payout`, params}, options);
}

export async function getTaxReportData(params, options={}){
  return httpService.GET({url: `:businessId:/tax/dashboard`, params}, options);
};
export async function downloadTaxInvoices(params, options={}) {
  const configs = { headers: {'accept': "*/*"} };
  return httpService.FILE({url: `:businessId:/tax/invoices`, params, configs}, options);
}

export async function getInmatesReportData(params, options={}){
  return httpService.GET({url: `:businessId:/reports/inmate`, params}, options);
};

export async function getAvailabilityReportData(params, options={}){
  return httpService.GET({url: `:businessId:/reports/availability`, params}, options);
};

export async function downloadReportFile(type, params={}, options={}) {
  const configs = { headers: {'accept': "*/*"} };
  return httpService.FILE({url: `:businessId:/reports/${type}`, configs, params}, options);
}
/** Partial Payment */
export async function getPartialPaymentsReportData(params, options={}){
  return httpService.GET({url: `:businessId:/reports/partialPayment`, params}, options);
};
export async function downloadPartialPaymentsReport(params, options={}) {
  return httpService.FILE({url: `:businessId:/reports/partialPayment`, params}, options);
}
